// src/constant/rolePermissionsConfig.js

// Esto lo usaremos para mostrar en distintas vistas
export const subRoleLabels = {
  apGeneral: "Administrador general",
  apAdministrativo: "Personal administrativo",
  apProfesional: "Personal profesional",
  omicGeneral: "Usuario Municipal"
};
// Devuelvo la etiqueta del sub rol. Solo hay que importar rolePermissionsConfig en cualquier componente
export const getSubRoleLabel = (subRoleKey) => {
  if (!subRoleKey) return "Sin subrol";
  return subRoleLabels[subRoleKey] || subRoleKey;
};

// Lo usamos para evaluar permisos en la interfaz del front
export const hasPermission = (permissionValue, account) => {
  // Si no hay cuenta o no tiene roles, no tiene permisos
  if (!account || !account.roles) return false;
  // Usamos .some() para verificar si al menos uno de los roles del usuario cumple con el permiso
  return account.permissions.some(p => p.value === permissionValue);
};

/**
 * Diccionario de permisos excluidos (desmarcados por defecto) según el rol.
 * Cada clave corresponde al 'value' del rol y contiene un array con los 
 * identificadores de los permisos que deben iniciar desmarcados.
 */
export const excludedPermissionsByRole = {
  apGeneral: [],
  apAdministrativo: [
    "admin",
    "manage_user_profiles",
    "configuracion_sistema",
    "configure_system_parameters",
    "configure_roles_and_permissions",
    "manage_users",
    "reassign_claims",
    "gestion_usuarios",
    "reject_claims_with_reason"
  ],
  apProfesional: [
    "admin",
    "manage_user_profiles",
    "configuracion_sistema",
    "configure_system_parameters",
    "configure_roles_and_permissions",
    "manage_users",
    "gestion_usuarios"
  ],
  omicGeneral: [
    "reassign_claims_within_municipality"
  ],
  /* support: [
    "admin",
    "configuracion_sistema"
  ] */
};

// Referencias con  y identificador en español:
/*
  ==================================================================================================================================================================
  REFERENCIA DE PERMISOS - CONFIGURACIÓN COMPLETA (Etiqueta / Label | Valor Técnico / Value)
  ==================================================================================================================================================================
  Acceder al historial de cambios de estado y acciones realizadas sobre los reclamos                      | access_claims_change_history
  Acceso a Reportes y Estadísticas                                                                        | acceso_reportes_estadisticas
  Adjuntar documentación adicional a los reclamos                                                         | attach_documents_to_claims
  Admin                                                                                                   | admin
  Administrar perfiles de usuario (Administradores, Usuarios Municipales, Soporte Técnico)                | manage_user_profiles
  Asignar reclamos                                                                                        | assign_claims
  Asignar reclamos a responsables específicos dentro de municipios                                        | assign_claims_to_specific_responsibles
  Cerrar tickets de soporte técnico                                                                       | close_support_tickets
  Configuración del Sistema                                                                               | configuracion_sistema
  Configurar parámetros del sistema                                                                       | configure_system_parameters
  Configurar roles y permisos específicos para cada usuario                                               | configure_roles_and_permissions
  Consultar el historial de acciones realizadas sobre los tickets de soporte                              | view_ticket_action_history
  Consultar el registro de todas las notificaciones enviadas y acciones realizadas                        | view_notifications_and_actions_log
  Consultar indicadores clave de rendimiento (KPI) por municipio                                          | view_kpis_by_municipality
  Crear, editar y desactivar usuarios                                                                     | manage_users
  Desasignar y reasignar reclamos                                                                         | reassign_claims
  Escalar tickets entre niveles (N1, N2, N3)                                                              | escalate_tickets
  Exportar datos en PDF, Excel y CSV                                                                      | export_data
  Exportar datos en PDF, Excel y CSV (dentro de su jurisdicción)                                          | export_jurisdiction_data
  Generar documentos GEDO (Documento Electrónico GDEBA)                                                   | generate_gedo_documents
  Generar informes de indicadores                                                                         | generate_reports
  Generar informes de indicadores de su jurisdicción                                                      | generate_jurisdiction_reports
  Gestión de Reclamos                                                                                     | gestion_reclamos
  Gestión de Tickets                                                                                      | gestion_tickets
  Gestión de Usuarios                                                                                     | gestion_usuarios
  Gestionar tickets asignados                                                                             | manage_assigned_tickets
  Reasignar reclamos a otros usuarios dentro del municipio                                                | reassign_claims_within_municipality
  Rechazar reclamos y registrar el motivo                                                                 | reject_claims_with_reason
  Trazabilidad y Auditoría                                                                                | trazabilidad_auditoria
  Visualización y Manejo de Documentos                                                                    | visualizacion_manejo_documentos
  Visualizar los reclamos asignados al municipio                                                          | view_assigned_claims
  Visualizar mensajes de soporte técnico                                                                  | view_technical_support_messages
  Visualizar y descargar reportes                                                                         | view_and_download_reports
  Visualizar y descargar reportes de su municipio                                                         | view_and_download_municipality_reports
  ==================================================================================================================================================================
*/

/* Permisos Admin Disponibles
access_municipality_claims_history
access_claims_change_history
acceso_reportes_estadisticas
attach_documents_to_claims
admin
manage_user_profiles
assign_claims
assign_claims_to_specific_responsibles
configuracion_sistema
configure_system_parameters
configure_roles_and_permissions
view_notifications_and_actions_log
view_kpis_by_municipality
manage_users
reassign_claims
export_data
export_jurisdiction_data
generate_gedo_documents
generate_reports
generate_jurisdiction_reports
gestion_reclamos
gestion_tickets
gestion_usuarios
reassign_claims_within_municipality
reject_claims_with_reason
trazabilidad_auditoria
visualizacion_manejo_documentos
view_assigned_claims
view_technical_support_messages
view_and_download_reports
view_and_download_municipality_reports
 */

/* export const excludedPermissionsByRole = {
  admin: [
    "view_support_messages"
  ],
  omic: [
    "acceso_reportes_estadisticas",
    "admin",
    "configuracion_sistema",
    "configure_system_parameters",
    "manage_user_profiles"
  ],
  support: [
    "admin",
    "configuracion_sistema",
    "assign_claims"
  ],
  admin_prov: [
    "acceso_reportes_estadisticas",
    "attach_documents_to_claims"
  ]
}; */